<template> 
  <div  class="common-layout">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App', 
}
</script>

<style>
  
.common-layout {
    padding: 0px;
    margin: 0px;
    min-height: 100%; 
}
</style>
